var _defs, _rect, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNegative(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 400,
    viewBox: "0 0 800 400",
    role: "img",
    "aria-label": "\\u0424\\u043E\\u0442\\u043E\\u043F\\u043B\\u0451\\u043D\\u043A\\u0430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "filmClip"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 60,
    width: 720,
    height: 280,
    rx: 16
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 60,
    width: 720,
    height: 280,
    rx: 16,
    fill: "#2E2E38"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F6F7F8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 78,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 78,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 78,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 78,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 78,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 78,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 78,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 78,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594,
    y: 78,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 78,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708,
    y: 78,
    width: 26,
    height: 18,
    rx: 4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#F6F7F8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 304,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 304,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 304,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 304,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330,
    y: 304,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396,
    y: 304,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462,
    y: 304,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 528,
    y: 304,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 594,
    y: 304,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660,
    y: 304,
    width: 26,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 708,
    y: 304,
    width: 26,
    height: 18,
    rx: 4
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#filmClip)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 112,
    width: 150,
    height: 176,
    rx: 6,
    fill: "#458FF6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 112,
    width: 150,
    height: 176,
    rx: 6,
    fill: "#FC724D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 112,
    width: 150,
    height: 176,
    rx: 6,
    fill: "#458FF6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610,
    y: 112,
    width: 150,
    height: 176,
    rx: 6,
    fill: "#FC724D"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F6F7F8",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 220,
    width: 24,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 196,
    width: 28,
    height: 84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 232,
    width: 20,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 208,
    width: 26,
    height: 72
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 245,
    cy: 150,
    r: 14
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F6F7F8",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 292,
    y: 228,
    width: 22,
    height: 52
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 200,
    width: 26,
    height: 80
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 240,
    width: 18,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376,
    y: 212,
    width: 24,
    height: 68
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400 212 L412 190 L424 212 Z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F6F7F8",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 458,
    y: 216,
    width: 24,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 488,
    y: 192,
    width: 30,
    height: 88
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524,
    y: 236,
    width: 20,
    height: 44
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 503,
    cy: 150,
    r: 16
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#F6F7F8",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("rect", {
    x: 624,
    y: 224,
    width: 22,
    height: 56
  }), /*#__PURE__*/React.createElement("rect", {
    x: 652,
    y: 196,
    width: 26,
    height: 84
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684,
    y: 232,
    width: 20,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 710,
    y: 208,
    width: 24,
    height: 72
  }), /*#__PURE__*/React.createElement("rect", {
    x: 740,
    y: 244,
    width: 16,
    height: 36
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.6fd6b023f3d063bd17b863457fac0b43.svg";
export { ForwardRef as ReactComponent };